import { Component, OnInit } from '@angular/core';
import { PageComponent } from '@icc/helpers';
import { _ } from '@icc/configurator/shared';
import { HardwareService } from '../hardware/hardware.service';
import { DoorFacade } from '../+state/door.facade';
import { ConfigurationsService } from '@icc/common/configurations/configurations.service';

@Component({
    selector: 'icc-cylinders-page',
    templateUrl: './cylinders-page.component.html',
    styleUrls: ['./cylinders-page.component.scss'],
})
export class CylindersPageComponent extends PageComponent implements OnInit {
    public title = _('DOOR|Wkładki');
    public options = [];

    cylinderMainLock$ = this.doorFacade.cylinderMainLock$;
    cylinderAdditionalLock$ = this.doorFacade.cylinderAdditionalLock$;
    cylinderSystem$ = this.doorFacade.cylinderSystem$;
    electronicLock$ = this.doorFacade.electronicLock$;

    isKeyAvailableForMainLock: boolean;
    isKeyAvailableForAdditionalLock: boolean;

    constructor(
        private hardwareService: HardwareService,
        private doorFacade: DoorFacade,
        private configurationsService: ConfigurationsService<'door'>,
    ) {
        super();
    }

    ngOnInit() {
        const conf = this.configurationsService.conf.Current
        this.isKeyAvailableForMainLock = conf.doorHardware.cylinders.isKeyAvailableForMainLock
        this.isKeyAvailableForAdditionalLock = conf.doorHardware.cylinders.isKeyAvailableForAdditionalLock
    }

    changeCylinderToMainLock() {
        this.hardwareService.openCylinderToMainLockModal();
    }

    changeCylinderToAdditionalLock() {
        this.hardwareService.openCylinderToAdditionalLockModal();
    }

    changeCylinderSystem() {
        this.hardwareService.openCylinderSystemModal();
    }

    changeElectronicLock() {
        this.hardwareService.openElectronicLockModal();
    }

    changeDecorativeHingeCover() {
        this.hardwareService.openModalDecorativeHingeCoverOptions();
    }

    changeCylinderToMainLockOptions() {
        this.hardwareService.openModalCylinderToMainLockOptions();
    }

    changeCylinderToAdditionalLockOptions() {
        this.hardwareService.openModalCylinderToAdditionalLockOptions();
    }

    isCylinderMainLockButtonDisabled() {
        const cylindersToMainLock = this.hardwareService.getCylindersToMainLock();
        const cylindersToMainLockLength = cylindersToMainLock.length;
        if(cylindersToMainLockLength > 1) {
            return false;
        }
        return true;
    }

    isCylinderAdditionalLockButtonDisabled(){
        const cylindersToAdditionalLock = this.hardwareService.getCylindersToAdditionalLock();
        const cylindersToAdditonalLockLength = cylindersToAdditionalLock.length;
        if(cylindersToAdditonalLockLength > 1) {
            return false;
        }
        return true;
    }

    isCylinderSystemButtonDisabled() {
        const cylidnerSystem = this.hardwareService.getCylinderSystems();
        const cylinderSystemLength = cylidnerSystem.length;
        if(cylinderSystemLength > 1) {
            return false;
        }
        return true;
    }

    isElectronickLockButtonDisabled() {
        const electronickLockLength = this.hardwareService.electronicLocks.length
        
        if(electronickLockLength > 1) {
            return false;
        }
        return true;
    }

}
